import React, { useState } from 'react';

const mobileWithInPixels = '768';

export const useIsMobile = () => {
  const [isMobile, setMobile] = useState<boolean>();

  React.useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleResize = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        if (
          window.matchMedia('(max-width:' + mobileWithInPixels + 'px)').matches
        ) {
          setMobile(true);
        } else {
          setMobile(false);
        }
      }, 200);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return isMobile;
};
